import { render } from "./hire.vue?vue&type=template&id=036f9c74&scoped=true"
import script from "./hire.vue?vue&type=script&lang=js"
export * from "./hire.vue?vue&type=script&lang=js"

import "./hire.vue?vue&type=style&index=0&id=036f9c74&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-036f9c74"]])

export default __exports__